<template>
  <div class="agenda">
    <div class="shadowbg shadowbg--agenda"></div>
    <title-comp>
      <h1 class="grey text--center">
        Plongez<br>
        dans la<br>
        nouvelle<br>
        <span>saison</span><br>
        <span>2019-2020</span>
      </h1>
    </title-comp>

    <div class="agenda__filters text--center">
      <p class="small">Filtrer la programmation par :</p>
      <ul class="inline">

        <li :class="['filter--black', isActive('all')]" v-on:click="filter('all')">Tout</li>
        <li :class="['filter--pink', isActive('opera')]" v-on:click="filter('opera')">Opéra</li>
        <li :class="['filter--green', isActive('ballet')]" v-on:click="filter('ballet')">Ballet</li>
      </ul>
    </div>

    <div class="row">
      <div class="col-8 col-sm-12 padd--mobile">
        <div class="row row--wrap row--align-left agenda__events">

          <event v-for="event in events" :event="event" :key="event.title" class="transition" parallax="true" />

          <div class="event event--abo" v-in-viewport.once data-opera="1" data-ballet="1">
            <div>
              <div class=" imagewrapper pb-138"></div>
              <div class="abs--center">
                <img src="/images/logo-white.png" class="logo" />
                <p class="title-h2">
                  Récitals &amp;<br>
                  <span>Concerts</span>
                </p>
                <!-- <router-link to="identite#abonnements" class="round-button">Découvrir</router-link> -->
                <a target="_blank" href="/pdf/Recitals_et_concert_red.pdf" class="round-button">Découvrir</a>
              </div>
            </div>
          </div>

          <div class="event event--abo" v-in-viewport.once data-opera="1" data-ballet="1">
            <div>
              <div class=" imagewrapper pb-138"></div>
              <div class="abs--center">
                <img src="/images/logo-white.png" class="logo" />
                <p class="title-h2">
                  Découvrez<br>
                  <span>la program-<br>
                  mation<br>
                  complète</span>
                </p>
                <a href="/pdf/GTG_Oser-l-espoir_saison19-20.pdf" class="round-button round-button--44" target="_blank">Télécharger la brochure<br> de la saison</a>
                <a href="https://issuu.com/geneveopera/docs/gtg_programme_19-20" class="round-button" target="_blank">Voir la brochure en ligne</a>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>

    <twitter-feed />
  </div>
</template>

<style lang="scss">
.agenda{
  padding-top: 15%;
  @media #{$bp-sm}{
    padding-top: 18rem;
  }

  &__filters{
    ul{
      margin-top: 3.5rem;
      margin-bottom: 12rem;
    }
    li{
      width: 21rem;
      height: 7rem;
      line-height: 7rem;
      text-align: center;
      border-radius: 3.5rem;
      margin: 0 5px;
      opacity: 0.35;
      transition: all .3s ease-out;
      cursor: pointer;
      @include TIMES;

      &:hover,
      &.filter--active{
        color: white !important;
        opacity: 1;
      }

      &.filter--black{
        color: black;
        border: 1px solid black;
        &:hover,
        &.filter--active{
          background-color: black;
        }
      }
      &.filter--pink{
        color: $pink;
        border: 1px solid $pink;
        &:hover,
        &.filter--active{
          background-color: $pink;
        }
      }
      &.filter--green{
        color: $green;
        border: 1px solid $green;
        &:hover,
        &.filter--active{
          background-color: $green;
        }
      }
      &.filter--blue{
        color: $blue;
        border: 1px solid $blue;
        &:hover,
        &.filter--active{
          background-color: $blue;
        }
      }

      @media #{$bp-sm}{
        display: block;
        margin: 0 auto 10px;
      }
    }
  }

  &__events{
    margin-bottom: 30%;
    .col--mid-marg{
      position: relative;
    }
    > div{
      &:nth-child(2n){
        .event{
          position: absolute;
          margin-top: 20%;
        }
      }
    }

    .event{
      position: absolute;
      width: calc( 50% - 10px );
      transition: opacity .7s ease, transform .3s ease;
      &--inactive{
        opacity: 0;
      }
      @media #{$bp-sm}{
        width: 100%;
      }
    }
  }
}
</style>

<script>
import TwitterFeed from '../components/TwitterFeed.vue';
import Event from '../components/Event.vue';
import TitleComp from '../components/TitleComp.vue';
import css from 'dom-css'

export default {
  components: {
    TwitterFeed, Event, TitleComp
  },
  data() {
    return {
      all: true,
      opera: true,
      ballet: true,
      isMobile: false,
      events: this.$events
    };
  },
  methods: {
    isActive( type ){
      let active = false
      if( this.all ){
        if( type == 'all' ){
          active = true
        }
      }else{
        switch( type ){
          case 'opera':
            if( this.opera ) active = true
            break;
          case 'ballet':
            if( this.ballet ) active = true
            break;
        }
      }

      if( active ){
        return 'filter--active'
      }
    },
    filter( type ){
      if( type != undefined ){
        if( type != 'all' ){
          this.all = false
          this.opera = false
          this.ballet = false
          switch( type ){
            case 'opera':
              this.opera = true
              break;
            case 'ballet':
              this.ballet = true
              break;
          }
        }else{
          this.all = true
          this.opera = true
          this.ballet = true
        }
      }

      this.availableItems = []
      let item, active
      for( let i = 0, lg = this.items.length; i<lg; i++ ){
        item = this.items[ i ]
        active = false
        if( this.all ) active = true
        else if( this.opera && item.dataset.opera == '1' ) active = true
        else if( this.ballet && item.dataset.ballet == '1' ) active = true

        if( active ){
          item.classList.remove('event--inactive')
          this.availableItems.push( item )
        }else{
          item.classList.add('event--inactive')
        }
      }

      this.setPositions()
    },
    setPositions(){
      let item, x, y, h
      for( let i = 0, lg = this.availableItems.length; i<lg; i++ ){
        item = this.availableItems[ i ]
        if( this.isMobile ){
          x = 0
          y = i * (this.height + 20)
        }else{
          x = (i % 2) * (this.width + 20)
          y = Math.floor(i / 2) * (this.height + 20)
          if( i%2 == 1 ) y += 180
        }
        css( item, 'transform', 'translate3d(' + x + 'px, ' + y + 'px, 0)')
      }

      if( this.isMobile ){
        h = this.availableItems.length * (this.height+20)
      }else{
        h = Math.round(this.availableItems.length / 2 + 0.1) * (this.height+20)
      }

      css( this.container, 'height', h )
    },
    resize(){
      this.isMobile = ! (window.innerWidth > 768)

      let box = this.items[0].getBoundingClientRect()
      this.width = box.width
      this.height = box.height
      this.filter()
    }
  },

  mounted(){
    this.container = this.$el.querySelector('.agenda__events')
    this.items = this.container.querySelectorAll('.event')
    this.resize()

    if( this.$route.path.indexOf('ballet') != -1 ){
      this.filter('ballet')
    }else if( this.$route.path.indexOf('opera') != -1 ){
      this.filter('opera')
    }

    window.addEventListener('resize', ()=>this.resize())
  }

};
</script>
